import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bookcabfrompunetomumbai() {



  const cardData = {


  keyword: "Book Cab from Pune to Mumbai",

  headingDescription: "Trustline Travels makes it easy to book a cab from Pune to Mumbai with reliable, comfortable, and affordable taxi services for business trips, airport transfers, family vacations, corporate travel, and outstation journeys. Whether you need a one-way taxi, round-trip cab, or customized travel package, our experienced chauffeurs ensure timely pickups and a safe, hassle-free journey. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, instant booking confirmation, doorstep pickup, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted partner for Pune to Mumbai cab booking services.",

  topPlaces: [
    {
      title: "Andheri East",
      description: "Andheri East is a major commercial destination featuring corporate offices, business hotels, IT companies, and excellent connectivity to Mumbai Airport."
    },
    {
      title: "Worli",
      description: "Worli is one of Mumbai's premium business districts, known for commercial towers, financial institutions, luxury hotels, and seamless connectivity."
    },
    {
      title: "Kurla",
      description: "Kurla is a fast-growing commercial hub with corporate offices, shopping centers, transport facilities, and easy access to eastern and western suburbs."
    },
    {
      title: "Malad",
      description: "Malad is a thriving business and residential locality with IT parks, commercial complexes, shopping malls, and modern infrastructure."
    },
    {
      title: "Godrej IT Park",
      description: "Godrej IT Park offers world-class office spaces for technology companies, startups, and multinational corporations in a modern business environment."
    },
    {
      title: "SEEPZ MIDC",
      description: "SEEPZ MIDC is one of India's leading export processing zones, home to IT companies, electronics manufacturers, and software development firms."
    },
    {
      title: "Powai Lake",
      description: "Powai Lake is a beautiful urban lake surrounded by greenery, cafés, and modern developments, making it a popular leisure destination."
    },
    {
      title: "Elephanta Caves",
      description: "Elephanta Caves is a UNESCO World Heritage Site famous for its ancient rock-cut temples and remarkable sculptures dedicated to Lord Shiva."
    },
    {
      title: "Aksa Beach",
      description: "Aksa Beach is a peaceful coastal destination known for its scenic shoreline, relaxing atmosphere, and refreshing sea breeze."
    },
    {
      title: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya",
      description: "This iconic museum showcases India's rich heritage through remarkable collections of art, archaeology, natural history, and cultural exhibits."
    }
  ],






"services": [
  {
    "name": "Book Cab from Pune to Mumbai",
    "description": "Book cab from Pune to Mumbai with safe, comfortable, and affordable chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for one-way, round-trip, airport transfers, corporate travel, and family trips."
  },
  {
    "name": "Cab Service from Pune to Mumbai",
    "description": "Choose our Pune to Mumbai cab service for reliable pickups, transparent fares, professional drivers, clean AC cars, and 24x7 customer support."
  },
  {
    "name": "Mumbai to Pune Cab Booking",
    "description": "Book Mumbai to Pune cab booking with instant confirmation, doorstep pickup, multiple vehicle options, and affordable pricing."
  },
  {
    "name": "Cab Booking Pune to Mumbai",
    "description": "Reserve your Pune to Mumbai cab booking online with flexible travel options, fixed pricing, and experienced chauffeurs."
  },
  {
    "name": "Cab Service from Mumbai to Pune",
    "description": "Book Mumbai to Pune cab service for safe, comfortable, and hassle-free travel with professional drivers and sanitized vehicles."
  },
  {
    "name": "Intercity Cabs Pune to Mumbai",
    "description": "Hire intercity cabs from Pune to Mumbai for business travel, airport transfers, family trips, and outstation journeys."
  },
  {
    "name": "One Way Cab from Pune to Mumbai",
    "description": "Book one way cab from Pune to Mumbai and pay only for your single journey with affordable fares and no return charges."
  },
  {
    "name": "Book Cab from Pune to Mumbai Airport",
    "description": "Book cab from Pune to Mumbai Airport for timely airport drop and pickup with professional drivers and spacious luggage capacity."
  },
  {
    "name": "Book Taxi from Mumbai to Pune",
    "description": "Hire taxi from Mumbai to Pune with clean AC vehicles, experienced chauffeurs, and transparent pricing."
  },
  {
    "name": "Cab Booking from Pune to Mumbai Airport",
    "description": "Book Pune to Mumbai Airport cab online with instant confirmation, reliable service, and fixed pricing."
  },
  {
    "name": "One Way Taxi from Pune to Mumbai",
    "description": "Choose one way taxi from Pune to Mumbai for affordable intercity travel with comfortable AC cars and experienced drivers."
  },
  {
    "name": "Pune to Mumbai Airport Taxi Service",
    "description": "Our Pune to Mumbai Airport taxi service offers punctual pickups, flight tracking, professional drivers, and comfortable vehicles."
  },
  {
    "name": "Pune to Mumbai Car Booking",
    "description": "Book Pune to Mumbai car online with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicle options."
  },
  {
    "name": "Innova Crysta Pune to Mumbai Cab",
    "description": "Hire Innova Crysta Pune to Mumbai cab for premium family travel, corporate trips, and airport transfers."
  },
  {
    "name": "Ertiga Pune to Mumbai Cab",
    "description": "Book Ertiga Pune to Mumbai cab for affordable 6 to 7 seater travel with comfortable seating and ample luggage space."
  },
  {
    "name": "Sedan Pune to Mumbai Cab",
    "description": "Choose Sedan Pune to Mumbai cab for economical one-way, airport, and business travel."
  },
  {
    "name": "Kia Carens Pune to Mumbai Cab",
    "description": "Hire Kia Carens Pune to Mumbai cab for spacious family trips and comfortable long-distance travel."
  },
  {
    "name": "Swift Dzire Pune to Mumbai Cab",
    "description": "Book Swift Dzire Pune to Mumbai cab for affordable, fuel-efficient, and comfortable outstation travel."
  },
  {
    "name": "Hyundai Aura Pune to Mumbai Cab",
    "description": "Travel in a Hyundai Aura Pune to Mumbai cab with reliable service, AC comfort, and budget-friendly pricing."
  },
  {
    "name": "SUV Cab Pune to Mumbai",
    "description": "Hire SUV cab Pune to Mumbai for group travel, extra luggage, and comfortable long-distance journeys."
  },
  {
    "name": "Luxury Cab Pune to Mumbai",
    "description": "Book luxury cab Pune to Mumbai with premium vehicles, professional chauffeurs, and executive-class travel experience."
  },
  {
    "name": "Premium Cab Pune to Mumbai",
    "description": "Choose premium cab Pune to Mumbai for comfortable business trips, airport transfers, and luxury travel."
  },
  {
    "name": "Family Cab Pune to Mumbai",
    "description": "Book family cab Pune to Mumbai with spacious seating, luggage space, and safe travel for families."
  },
  {
    "name": "Hinjewadi to Mumbai Cab",
    "description": "Book Hinjewadi to Mumbai cab with doorstep pickup, transparent fares, and reliable intercity taxi service."
  },
  {
    "name": "Wakad to Mumbai Cab",
    "description": "Hire Wakad to Mumbai cab for airport transfers, business travel, and one-way or round-trip journeys."
  },
  {
    "name": "Baner to Mumbai Cab",
    "description": "Choose Baner to Mumbai cab for affordable outstation travel with clean AC vehicles and experienced drivers."
  },
  {
    "name": "Kharadi to Mumbai Cab",
    "description": "Book Kharadi to Mumbai cab for airport transfers, corporate travel, and family trips."
  },
  {
    "name": "Hadapsar to Mumbai Cab",
    "description": "Hire Hadapsar to Mumbai cab with affordable fares, instant booking, and professional chauffeurs."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Cab",
    "description": "Book Pimpri Chinchwad to Mumbai cab for reliable airport transfers, one-way, and round-trip taxi services."
  },
  {
    "name": "Viman Nagar to Mumbai Cab",
    "description": "Choose Viman Nagar to Mumbai cab for quick airport connectivity, business travel, and comfortable journeys."
  },
  {
    "name": "Kothrud to Mumbai Cab",
    "description": "Book Kothrud to Mumbai cab with transparent pricing, AC vehicles, and experienced drivers."
  },
  {
    "name": "Shivajinagar to Mumbai Cab",
    "description": "Hire Shivajinagar to Mumbai cab for safe, affordable, and reliable intercity travel."
  },
  {
    "name": "Aundh to Mumbai Cab",
    "description": "Book Aundh to Mumbai cab with Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicle options."
  },
  {
    "name": "Corporate Cab Booking Pune to Mumbai",
    "description": "Corporate cab booking Pune to Mumbai for executive travel, employee transport, airport transfers, and business meetings."
  },
  {
    "name": "Executive Cab Pune to Mumbai",
    "description": "Hire executive cab Pune to Mumbai with premium vehicles, professional chauffeurs, and comfortable business travel."
  },
  {
    "name": "Business Travel Pune to Mumbai",
    "description": "Business travel Pune to Mumbai with reliable chauffeur-driven cabs, punctual pickups, and flexible travel schedules."
  },
  {
    "name": "Employee Transport Pune to Mumbai",
    "description": "Employee transport Pune to Mumbai with safe, comfortable, and dependable cab services for corporate organizations."
  },
  {
    "name": "Corporate Taxi Pune to Mumbai",
    "description": "Book corporate taxi Pune to Mumbai with premium AC vehicles, experienced drivers, and affordable corporate travel solutions."
  },
  {
    "name": "Pune to Mumbai Cab Booking",
    "description": "Book Pune to Mumbai cab online with instant confirmation, fixed pricing, and multiple vehicle choices."
  },
  {
    "name": "Pune to Mumbai Cab",
    "description": "Travel comfortably with Pune to Mumbai cab service offering one-way, round-trip, airport, and outstation travel."
  },
  {
    "name": "Book Pune to Mumbai Cab",
    "description": "Reserve your Pune to Mumbai cab with easy online booking, transparent pricing, and professional drivers."
  },
  {
    "name": "Online Pune to Mumbai Cab Booking",
    "description": "Online Pune to Mumbai cab booking with instant confirmation, secure reservations, and 24x7 customer assistance."
  },
  {
    "name": "Pune to Mumbai Taxi Booking",
    "description": "Book Pune to Mumbai taxi with affordable fares, AC vehicles, and experienced chauffeurs."
  },
  {
    "name": "Pune to Mumbai Taxi Service",
    "description": "Reliable Pune to Mumbai taxi service for airport transfers, corporate travel, family trips, and outstation journeys."
  }
],

"tableData": [
  ["Book Cab from Pune to Mumbai", "Cab Service from Pune to Mumbai"],
  ["Mumbai to Pune Cab Booking", "Cab Booking Pune to Mumbai"],
  ["Cab Service from Mumbai to Pune", "Intercity Cabs Pune to Mumbai"],
  ["One Way Cab from Pune to Mumbai", "Book Cab from Pune to Mumbai Airport"],
  ["Book Taxi from Mumbai to Pune", "Cab Booking from Pune to Mumbai Airport"],
  ["One Way Taxi from Pune to Mumbai", "Pune to Mumbai Airport Taxi Service"],
  ["Pune to Mumbai Car Booking", "Innova Crysta Pune to Mumbai Cab"],
  ["Ertiga Pune to Mumbai Cab", "Sedan Pune to Mumbai Cab"],
  ["Kia Carens Pune to Mumbai Cab", "Swift Dzire Pune to Mumbai Cab"],
  ["Hyundai Aura Pune to Mumbai Cab", "SUV Cab Pune to Mumbai"],
  ["Luxury Cab Pune to Mumbai", "Premium Cab Pune to Mumbai"],
  ["Family Cab Pune to Mumbai", "Hinjewadi to Mumbai Cab"],
  ["Wakad to Mumbai Cab", "Baner to Mumbai Cab"],
  ["Kharadi to Mumbai Cab", "Hadapsar to Mumbai Cab"],
  ["Pimpri Chinchwad to Mumbai Cab", "Viman Nagar to Mumbai Cab"],
  ["Kothrud to Mumbai Cab", "Shivajinagar to Mumbai Cab"],
  ["Aundh to Mumbai Cab", "Corporate Cab Booking Pune to Mumbai"],
  ["Executive Cab Pune to Mumbai", "Business Travel Pune to Mumbai"],
  ["Employee Transport Pune to Mumbai", "Corporate Taxi Pune to Mumbai"],
  ["Pune to Mumbai Cab Booking", "Pune to Mumbai Cab"],
  ["Book Pune to Mumbai Cab", "Online Pune to Mumbai Cab Booking"],
  ["Pune to Mumbai Taxi Booking", "Pune to Mumbai Taxi Service"]
],





whychoose: [
  {
    WhyChooseheading: "Book Cab from Pune to Mumbai with Ease",
    WhyChoosedescription: "Trustline Travels offers quick and hassle-free Pune to Mumbai cab booking with reliable service for business, family, and airport travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "Our cabs are available for pickup from homes, hotels, offices, railway stations, and all major areas across Pune."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Fleet",
    WhyChoosedescription: "Travel in clean, air-conditioned Sedan, Ertiga, Innova, Innova Crysta, SUVs, or Tempo Travellers for a relaxing journey."
  },
  {
    WhyChooseheading: "Competitive Pricing with No Hidden Costs",
    WhyChoosedescription: "Enjoy transparent fare quotations with affordable pricing and complete clarity before confirming your booking."
  },
  {
    WhyChooseheading: "Safe Journey with Expert Drivers",
    WhyChoosedescription: "Our professional chauffeurs are experienced in long-distance travel and ensure a smooth ride on the Pune-Mumbai route."
  },
  {
    WhyChooseheading: "One Way, Round Trip & Airport Transfers",
    WhyChoosedescription: "Book flexible travel options including one-way cabs, round trips, Mumbai Airport transfers, and customized travel packages."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Assistance",
    WhyChoosedescription: "Our customer support team is available round the clock to help you book a cab whenever you need one."
  },
  {
    WhyChooseheading: "Preferred Choice for Outstation Travel",
    WhyChoosedescription: "Thousands of travelers trust Trustline Travels for punctual service, quality vehicles, and dependable Pune to Mumbai transportation."
  }
]

};

const faqData = [
  {
    question: "How can I book a cab from Pune to Mumbai with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  },
  {
    question: "Can I book a one-way cab from Pune to Mumbai?",
    answer: "Yes, Trustline Cab provides affordable one-way cab services with flexible pickup timings."
  },
  {
    question: "Do you offer round-trip cab booking?",
    answer: "Yes, we provide customized round-trip packages for business travel, family trips, sightseeing, and airport transfers."
  },
  {
    question: "Which vehicles can I book for Pune to Mumbai travel?",
    answer: "You can choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your travel requirements."
  },
  {
    question: "Do you provide Mumbai Airport cab service?",
    answer: "Yes, we provide direct cab services to Mumbai Airport Terminal 1, Terminal 2, and all major locations in Mumbai."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in your booking."
  },
  {
    question: "Is cab booking available 24 hours a day?",
    answer: "Yes, Trustline Travels offers 24/7 booking assistance and cab availability for your convenience."
  },
  {
    question: "Can I schedule my cab in advance?",
    answer: "Yes, advance booking is recommended to ensure your preferred vehicle and pickup time are available."
  },
  {
    question: "Do you provide cabs for corporate and family travel?",
    answer: "Yes, our Pune to Mumbai cab service is ideal for corporate executives, families, tourists, and group travelers."
  },
  {
    question: "Why should I choose Trustline Travels to book a cab from Pune to Mumbai?",
    answer: "Trustline Cab provides reliable service, experienced drivers, transparent pricing, well-maintained vehicles, and prompt customer support for every journey."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Gokhale",
    feedback: "Booking a cab from Pune to Mumbai with Trustline Travels was simple and convenient. The driver arrived on time, the car was spotless, and the journey was comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Nair",
    feedback: "Trustline Travels made our Pune to Mumbai trip completely hassle-free. From quick booking to professional service and a smooth ride, everything was managed perfectly.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Book Cab from Pune to Mumbai",
  "image": "https://www.trustlinetravels.com/assets/images/book-cab-from-pune-to-mumbai.webp",
  "description": "Book cab from Pune to Mumbai with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, and airport taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8457"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/book-cab-from-pune-to-mumbai"
  }
};







  return (
    <div>

<Helmet>
  <title>Book Cab from Pune to Mumbai | Intercity Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book cab from Pune to Mumbai with Trustline Travels for reliable intercity travel. Enjoy affordable one-way, round-trip, and airport cab services with Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis available 24x7."
  />

  <meta
    name="keywords"
    content="Book cab from pune to mumbai, Cab service from pune to mumbai, Mumbai to pune cab booking, Cab booking pune to mumbai, Cab service from mumbai to pune, Intercity cabs pune to mumbai, One way cab from pune to mumbai, Book cab from pune to mumbai airport, Pune Mumbai intercity taxi, Pune to Mumbai online cab booking, Pune Mumbai one way taxi, Mumbai Pune cab service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/63.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bookcabfrompunetomumbai;